module.exports = __webpack_public_path__ + "img/6.f03a804a.png";